import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientsComponent } from './clients.component';
import { ClientsRoutingModule } from "./clients-routing.module";
import { SharedModule } from "../../shared/shared.module";
import { ClientProfileComponent } from './profile/profile.component';
import { RouterModule } from '@angular/router';
// import { CampaignsComponent } from '../campaigns/campaigns.component';

@NgModule({
  imports: [
    CommonModule,
    ClientsRoutingModule,
    SharedModule,
    RouterModule
  ],
  declarations: [ClientsComponent, ClientProfileComponent]
})
export class ClientsModule { }



// WEBPACK FOOTER //
// ./src/app/components/clients/clients.module.ts